import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const DashboardPresentationReportConfig: ReportConfigBase = {
  type: EReportTypes.DashboardPresentation,
  endpoint: "order",
  reportKey: "orders",
  filtersBase: [],
  summaryBase: [],
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "The Dashboard Presentation Report provides detailed information about a rep's presentations",
    url: "https://help.commonsku.com/knowledge/sales-dashboard-report",
  },
};

export default DashboardPresentationReportConfig;
